var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMemberRoundHollow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: silver;\r\n        stroke: #000;\r\n        stroke-miterlimit: 10;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IconMemberRoundHollow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Border"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 48,
    height: 48
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "MemberRoundHollow"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24,30l-1.55-.2L21,29.2l-1.24-1L18.8,27l-.6-1.45L18,24l.2-1.55L18.8,21l1-1.24,1.24-1,1.45-.6L24,18l1.55.2,1.45.6,1.24,1,1,1.24.6,1.45L30,24l-.2,1.55L29.2,27l-1,1.24L27,29.2l-1.45.6Zm0,2,2.07-.27,1.93-.8,1.66-1.27L30.93,28l.8-1.93L32,24l-.27-2.07L30.93,20l-1.27-1.66L28,17.07l-1.93-.8L24,16l-2.07.27-1.93.8-1.66,1.27L17.07,20l-.8,1.93L16,24l.27,2.07.8,1.93,1.27,1.66L20,30.93l1.93.8.52.07Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMemberRoundHollow);
export default __webpack_public_path__ + "static/media/IconMemberRoundHollow.faffdce86e08a531b54fa8263ca26893.svg";
export { ForwardRef as ReactComponent };